const styles = theme => ({
  root: {
    maxWidth: 385,
    minWidth: 300,
    width: "350px",
    margin: theme.spacing(2),
    boxShadow: `2px 3px 18px rgba(0, 0, 0, .12)`,
    height: "100%",
    // minWidth: "350px",
    borderRadius: 4,
    [theme.breakpoints.down("md")]: {
      width: "250px"
    },
    [theme.breakpoints.down("sm")]: {
      width: "250px"
    }
  },

  header: {
    padding: `${theme.spacing(2)}px 0`,
    color: theme.palette.primary.default
  },
  moreIcon: {
    color: theme.palette.primary.light
  },
  media: {
    height: "auto"
  },
  // expand: {
  //   transform: "rotate(0deg)",
  //   marginLeft: "auto",
  //   transition: theme.transitions.create("transform", {
  //     duration: theme.transitions.duration.shortest
  //   })
  // },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    marginLeft: theme.spacing(2),
    background: theme.palette.primary.main
  },
  image: {
    display: "block",
    objectFit: "cover",
    width: "100%",
    height: "350px"
  },
  video: {
    height: "auto"
  },
  cardMedia: {
    position: "relative"
  },
  iconContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  playIcon: {
    color: "#fff",
    fontSize: "100px"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/AppCard/styles.js